module.exports = __webpack_public_path__ + "static/media/metc-blue-logo.0a0df21b.png";